import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/Homepage";
import SystemSubsystem from "./pages/SystemSubsystem";
import ProductsWeDeal from "./pages/ProductsWeDeal";
import CyberSecurity from "./pages/cyberSecurity";

import "./App.css";
import OurPartners from "./pages/OurPartners";
import AboutPage from "./pages/Aboutpage";
import FounderPage from "./pages/Founderpage";
import Contactpage from "./pages/Contactpage";

import RequestQuotepage from "./pages/RequestQuotepage";
import ProductDetails from "./pages/ProductDetails";
import ProductDetailsWe from "./pages/ProductDetailsWe";
import Certificates from "./pages/Certificates";
import Careers from "./pages/Careers";
import SectorDetail from "./components/SectorDetail";
import ApplicationDetail from "./components/ApplicationDetail";
import VisionSystem from "./pages/VisionSystem";
import VisionSystemDetails from "./pages/VisionSystemDetails";
import DronePage from "./pages/DronePage";
import CrauzetPage from "./pages/RailwaycrauzetPage";
import DronePageDetails from "./pages/DronePageDetails";
import CrauzetPageDetails from "./pages/RailwaycrauzetDetails";


import Event from "./components/EventsExabtionss";
import EventDetail from "./pages/EventDetail";
import PrivacyPolicy from "./pages/PrivacyPolicy";
function App() {


  return (
    <Router>
      <Navbar />
      {/* <main className="container" > */}
      <main >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/partners" element={<OurPartners/>}/>
          <Route path="/about" element={<AboutPage/>}/>
          <Route path="/founder" element={<FounderPage/>}/>
          <Route path="/certificates" element={<Certificates/>}/>
          <Route path="/Careers" element={<Careers/>}/>

{/* events and news */}
        <Route path="/" element={<Event />} />
        <Route path="/event/:id" element={<EventDetail   />} />  
          <Route path="/Contact" element={<Contactpage/>}/>
          <Route path="/OurProducts" element={<SystemSubsystem/>}/>
          <Route path="/VisionSystem" element={<VisionSystem/>}/>
          <Route path="/DroneSystem" element={<DronePage/>}/>
          <Route path="/crauzet" element={<CrauzetPage/>}/>
          <Route path="/crauzet/:id" element={<CrauzetPageDetails/>}/>
          <Route path="/viewDrone/:id" element={<DronePageDetails/>}/>
          <Route path="/Cybersecurity" element={<CyberSecurity/>}/>
          <Route path="/ProductsWeDeal" element={<ProductsWeDeal/>}/>
          <Route path="/request-quote" element={<RequestQuotepage/>}/>
          <Route path="/viewproduct/:id" element={<ProductDetails/>} />
          <Route path="/viewproductwe/:id" element={<ProductDetailsWe/>} />
          <Route path="/VisionSystemDetails/:id" element={<VisionSystemDetails/>} />

          <Route path="/sector/:id" element={<SectorDetail/>} />
          <Route path="/application/:id" element={<ApplicationDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
         
        </Routes>
      </main>
      <Footer/>
    </Router>
  );
}

export default App;
